import React from 'react';
import * as S from './Styled';

interface ErrorPageProps {
  message?: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => {
  return (
    <S.Container>
      <S.Content>
        <S.IconWrapper>
          <i className="fas fa-store-slash"></i>
        </S.IconWrapper>
        <S.Title>Loja não cadastrada</S.Title>
        <S.Message>
          {message || 'Verifique o endereço e tente novamente'}
        </S.Message>
      </S.Content>
    </S.Container>
  );
};
